<template>
  <div class="exam-content">
    <h3>2020迎“七•一”，党建知识竞赛</h3>
    <p>第九城市党总支</p>
    <p>恭喜你已经完成知识竞赛所有题目</p>
    <p>用时：{{examData.durations}}秒</p>
    <p>当前排名：{{examData.index+1}}名</p>
    <p>你与前一名相差{{examData.durations_difference}}秒，继续加油！</p>
    <p class="btn">
      <router-link :to="{name:'exam', params:{name:examData.name}}">再做一次</router-link>
      <router-link to="/">返回首页</router-link>
    </p>
  </div>
</template>
<script>
export default {
  data () {
    return {
      examData: ''
    }
  },
  created () {
    console.log(this.$route.params)
    this.examData = this.$route.params.re;
  }
}
</script>
<style scoped>
.exam-content {
  width: 100%;
}
.btn a {
  width: 100px;
  height: 40px;
  line-height: 40px;
  background-color: #07c160;
  display: inline-block;
  color: #fff;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/end.vue